import { ChevronDown } from 'lucide-react-native';
import { wrapLucideIcon } from './wrapLucideIcon';
wrapLucideIcon(ChevronDown);
export { ChevronDown as ChevronDownIcon };
